import "./TeamMember.css";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { usePreloader } from "../contexts/PreloaderContext";

gsap.registerPlugin(ScrollTrigger);

export function TeamMember({
  name,
  role,
  description,
  linkedInUri,
}: {
  name: string;
  role: string;
  description: string;
  linkedInUri: string;
}) {
  const memberRef = useRef<HTMLDivElement>(null);
  const { isComplete } = usePreloader();

  useEffect(() => {
    if (memberRef.current && isComplete) {
      gsap.fromTo(
        memberRef.current,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: memberRef.current,
            start: "top 85%",
            toggleActions: "play none none none",
          },
        },
      );
    }
  }, [isComplete]);

  return (
    <div className="team-member" ref={memberRef}>
      <h3 className="team-member__name">{name}</h3>
      <h4 className="team-member__role">{role}</h4>
      <p className="team-member__description">{description}</p>
      <a
        className="team-member__linkedin"
        href={linkedInUri}
        target="_blank"
        rel="noopener noreferrer"
      >
        LinkedIn Profile
      </a>
    </div>
  );
}
